// extracted by mini-css-extract-plugin
module.exports = {"root":"Y_bY","icon":"Y_bj","main-search-icon":"Y_dg","mainSearchIcon":"Y_dg","label-icon-default-filled":"Y_dh","labelIconDefaultFilled":"Y_dh"};